export const DELETE_SHOPIFY_CONNECTION = 'DELETE_SHOPIFY_CONNECTION';
export const SET_IS_LOADING_DELETE_SHOPIFY_CONNECTION = 'SET_IS_LOADING_DELETE_SHOPIFY_CONNECTION';
export const ADD_NEW_SHOPIFY_CONNECTION = 'ADD_NEW_SHOPIFY_CONNECTION';
export const SET_IS_LOADING_CREATE_SHOPIFY_CONNECTIONS = 'SET_IS_LOADING_CREATE_SHOPIFY_CONNECTIONS';
export const UPDATE_SHOPIFY_CONNECTION = 'UPDATE_SHOPIFY_CONNECTION';
export const SET_IS_LOADING_UPDATE_SHOPIFY_CONNECTIONS = 'SET_IS_LOADING_UPDATE_SHOPIFY_CONNECTIONS';
// Configuration
export const SET_CONFIGURATION = 'SET_CONFIGURATION';
export const SET_IS_LOADING_CONFIGURATION = 'SET_IS_LOADING_CONFIGURATION';
export const CREATE_UPDATE_CONFIGURATION = 'CREATE_UPDATE_CONFIGURATION';
export const SET_IS_LOADING_CREATE_UPDATE_CONFIGURATION = 'SET_IS_LOADING_CREATE_UPDATE_CONFIGURATION';
// Shopify queries
export const SET_QUERIES = 'SET_QUERIES';
export const SET_IS_LOADING_QUERIES = 'SET_IS_LOADING_QUERIES';
export const SET_QUERY_SELECTED = 'SET_QUERY_SELECTED';
export const DELETE_QUERY = 'DELETE_QUERY';
export const SET_IS_LOADING_DELETE_QUERY = 'SET_IS_LOADING_DELETE_QUERY';
export const UPDATE_QUERY = 'UPDATE_QUERY';
export const SET_IS_LOADING_UPDATE_QUERY = 'SET_IS_LOADING_UPDATE_QUERY';
// Shopify templates
export const SET_TEMPLATES = 'SET_TEMPLATES';
export const SET_IS_LOADING_TEMPLATES = 'SET_IS_LOADING_TEMPLATES';
export const SET_TEMPLATE_SELECTED = 'SET_TEMPLATE_SELECTED';
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';
export const SET_IS_LOADING_DELETE_TEMPLATE = 'SET_IS_LOADING_DELETE_TEMPLATE';
